import Vue from 'vue'
import api from 'Api'
import { uuid } from 'vue-uuid'

const URL = '/api-key'

const state = {
  api_keys: [],
  filtered_api_keys: [],
  activeApi_key: {}
}

const status = {
  api_keysLoading: false
}

const getters = {
  api_keys: state => {
    return state.api_keys
  },
  filtered_api_keys: state => {
    return state.filtered_api_keys
  },
  activeApi_key: state => {
    return state.activeApi_key
  }
}

function get (context, URL, handler) {
  return api().get(URL).then(response => handler(context, response))
}

function post (context, URL, data, handler) {
  return api().post(URL, data).then(response => handler(context, response))
}

function put (context, data, handler) {
  return api().put(URL, data).then(response => handler(context, response))
}

function apiDelete (context, URL, id, handler) {
  return api().delete(URL + '/' + id).then(response => handler(context, id, response))
}

function handleApiKeyLoad (context, response) {
  const apiKeys = response.data
  status.api_keysLoading = false
  if (apiKeys.error) {
    context.commit('apiError', apiKeys.error)
  } else {
    context.commit('api_keysLoaded', apiKeys)
  }
  return apiKeys
}

function handleApiKeySave (context, response) {
  const apiKey = response.data
  if (apiKey.error) {
    context.commit('apiError', apiKey.error)
  } else {
    context.commit('api_keySuccess', apiKey)
  }
}

function handleApiKeyDelete (context, id, response) {
  const apiKey = response.data
  if (apiKey.error) {
    context.commit('apiError', apiKey.error)
  } else {
    context.commit('api_keyDeleted', id)
  }
}

function handleGetApiKey (context, response) {
  const apiKey = response.data
  if (apiKey.error) {
    context.commit('apiError', apiKey.error)
  } else {
    context.commit('setActiveApi_key', apiKey)
  }
}

function replaceApiKey (state, apiKey) {
  state.api_keys = state.api_keys.filter(item => item.entity_id !== apiKey.entity_id)
  state.api_keys.push(apiKey)
  return state.api_keys
}

const actions = {
  loadApi_keys (context, payload) {
    if (status.api_keysLoading) {
      return
    }
    if (payload) {
      status.api_keysLoading = true
      return get(context, URL + '/organization/' + String(payload), handleApiKeyLoad)
    }
    return []
  },
  saveApi_key (context, payload) {
    const apiKeyData = {
      version: payload.version,
      entity_id: payload.entity_id,
      organization_id: payload.organization_id,
      name: payload.name,
      status: payload.status,
      key: payload.key
    }
    let req
    if (payload.entity_id) {
      req = put(context, apiKeyData, handleApiKeySave)
    } else {
      apiKeyData.entity_id = uuid.v4()
      apiKeyData.key = uuid.v4().replace(/-/g, '')
      req = post(context, URL, apiKeyData, handleApiKeySave)
    }
    context.commit('updateApi_keyData', apiKeyData)
    return req
  },
  deleteApi_key (context, id) {
    state.api_keys = state.api_keys.filter((apiKey) => apiKey.entity_id !== id)
    state.filtered_api_keys = state.filtered_api_keys.filter((apiKey) => apiKey.entity_id !== id)
    return apiDelete(context, URL, id, handleApiKeyDelete)
  },
  getApi_key (context, id) {
    const apiKeyArr = state.api_keys.filter(apiKey => apiKey.entity_id === id)
    if (apiKeyArr && apiKeyArr[0]) {
      context.commit('setActiveApi_key', apiKeyArr[0])
    }
    get(context, URL + '/' + id, handleGetApiKey)
  }
}

const mutations = {
  api_keysLoaded (state, apiKeys) {
    state.api_keys = apiKeys
    state.filtered_api_keys = [...state.api_keys]
  },
  api_keySuccess (state, apiKey) {
    state.api_keys = replaceApiKey(state, apiKey)
    state.filtered_api_keys = [...state.api_keys]
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Api_key Saved'
    })
  },
  api_keyDeleted (state, id) {
    state.api_keys = state.api_keys.filter((apiKey) => apiKey.entity_id !== id)
    state.filtered_api_keys = state.filtered_api_keys.filter((apiKey) => apiKey.entity_id !== id)
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Api_key deleted'
    })
  },
  setActiveApi_key (state, apiKey) {
    state.activeApi_key = apiKey
  },
  setFilteredApiKeys (state, filteredApiKeys) {
    state.filtered_api_keys = filteredApiKeys
  },
  updateApi_keyData (state, apiKey) {
    state.api_keys = replaceApiKey(state, apiKey)
    state.filtered_api_keys = [...state.api_keys]
  },
  resetFiltered_api_keys (state) {
    state.filtered_api_keys = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'apiKeyStore'
}
